export class ArrayHelper {
  public static arraysIntersects<TType>(a: TType[], b: TType[]): boolean {
    return a.some((value) => -1 !== b.indexOf(value));
  }
}
